module.exports = __webpack_public_path__ + "assets/retina_AMinPerimeterDetailed.df6863a8ad864166be113d2babd84b60.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/png/levels/2x/retina_AMinPerimeterDetailed.png
// module id = 607
// module chunks = 0